export const MainConfig = {
    AppDetails: {
        app_name: "Hav Lan",
        app_description: "HavLan Booking App",
        app_identifier: "com.alpha.havlan",
        ios_app_version: "2.5",
        android_app_version: 25
    },
    FirebaseConfig: {
        apiKey: "AIzaSyCGGUBBGDP7npF2rQGLf1typi_KkK1WUd8",
        authDomain: "hav-lan-demo.firebaseapp.com",
        databaseURL: "https://hav-lan-demo-default-rtdb.firebaseio.com",
        projectId: "hav-lan-demo",
        storageBucket: "hav-lan-demo.appspot.com",
        messagingSenderId: "711806639473",
        appId: "1:711806639473:web:8edc161638d7796e36ead0",
        measurementId: "G-GHK4THQJF3"
    },
    Google_Map_Key: "AIzaSyCGGUBBGDP7npF2rQGLf1typi_KkK1WUd8",
    facebookAppId: "879110896268025"
}